module.exports = __webpack_public_path__ + "img/fifth_cloud_bottom.64517c01.png";